import { render, staticRenderFns } from "./related-prompts-preview-item.component.vue?vue&type=template&id=9313609a&scoped=true"
import script from "./related-prompts-preview-item.component.vue?vue&type=script&lang=ts"
export * from "./related-prompts-preview-item.component.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-preview-item.component.vue?vue&type=style&index=0&id=9313609a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9313609a",
  null
  
)

export default component.exports